import React, {
    useRef,
    memo
} from 'react';
import PropTypes from 'prop-types';
import {
    IconButton,
    Typography
} from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';

function GenericMoreButton({ handleDownload, descargando, props }) {
    const moreRef = useRef(null);
    
    return (
        <>
            <IconButton
                {...props}
                onClick={() => {
                    handleDownload();
                }}
                disabled={descargando}
                ref={moreRef}
                size="small"
            >
                <GetAppIcon/>
                <Typography>
                    Exportar a Excel
                </Typography>
            </IconButton>
        </>
    );
}

GenericMoreButton.propTypes = {
    className: PropTypes.string
};

export default memo(GenericMoreButton);
